import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 获取图片验证码
import { getImgCode } from 'api/common';
// 登录api
import { registerApi, getRegisterShortCode } from 'api/login';
// token操作
import { utilCookies } from '@/util/cookies';
// button
import GlButton from '@/components/gl-button';
// 使用条款
var useUrl = new Map([['zh', 'https://fle.pub/7eX9h1'], ['en', 'https://fle.pub/1c4HBq'], ['th', 'https://fle.pub/9vKtuR']]);
export default {
  components: {
    GlButton: GlButton
  },
  data: function data() {
    var str = utilCookies.getLanguage() || 'en';
    return {
      lang: str,
      // 用户协议
      agreeUrl: '',
      // 使用条款
      useUrl: useUrl.get(str),
      // 图片验证码
      codeImg: '',
      disabled: {
        sendCode: false
      },
      surplusTime: -1,
      // 表单数据
      checked: false,
      ruleForm: {
        calling_code: '66',
        verify_code: '',
        sms_captcha_type: '1',
        // 1 注册 2 登录 3 重置密码 4 更换手机号
        mobile: ''
      },
      // 校验规则
      rules: {
        mobile: [{
          required: true,
          message: this.$t('login.35'),
          trigger: 'blur'
        }],
        verify_code: [{
          required: true,
          message: this.$t('login.36'),
          trigger: 'blur'
        }],
        captcha: [{
          required: true,
          message: this.$t('login.9'),
          trigger: 'blur'
        }]
      },
      // 按钮loading
      loading: false
    };
  },
  created: function created() {
    this.init();
  },
  computed: {
    isClick: function isClick() {
      var _this$ruleForm = this.ruleForm,
        calling_code = _this$ruleForm.calling_code,
        verify_code = _this$ruleForm.verify_code,
        mobile = _this$ruleForm.mobile,
        captcha = _this$ruleForm.captcha;
      var status = calling_code && verify_code && mobile && captcha && this.checked;
      return status;
    },
    codeText: function codeText() {
      if (this.surplusTime === -1) {
        return this.$t('login.4');
      }
      if (this.surplusTime === -2) {
        return this.$t('login.10');
      }
      return this.surplusTime > 0 ? "".concat(this.surplusTime, "S") : this.$t('login.4');
    }
  },
  methods: {
    init: function init() {
      var _this = this;
      this.agreeUrl = "https://backyard-api.flash-hr.com/auth/tool/terms?lang=".concat(this.lang);
      // 获取图片验证码
      this.handleImgCode();
      // 是否可以发送验证码
      // 全局mixin方法
      this.resetTimeCode(function (time) {
        if (time <= 0) {
          _this.disabled.sendCode = false;
        }
        _this.surplusTime = time;
      });
    },
    // 获取图片验证码
    handleImgCode: function handleImgCode() {
      var _this2 = this;
      // 图片验证码埋点
      this.$ga.event('FHRSignup', 'click', 'ImageVerificationCode', 1);
      getImgCode().then(function (res) {
        if (res && res.code === 1) {
          _this2.codeImg = res.data;
        }
      });
    },
    // 短信验证码
    handleShortCode: function handleShortCode() {
      var _this3 = this;
      this.ruleForm.sid = this.codeImg.sid;
      // 校验是否输入图片验证码和手机号
      if (this.ruleForm.sid && this.ruleForm.mobile && this.ruleForm.captcha) {
        this.surplusTime = -1;
        getRegisterShortCode(this.ruleForm).then(function (res) {
          if (res && res.code === 1) {
            // 短信验证码埋点
            _this3.$ga.event('FHRSignup', 'click', 'GetVerificationCode', 2);
            _this3.$message({
              message: _this3.$t('816'),
              type: 'success'
            });
            _this3.$s.set('codeTime', new Date().getTime());
            // 全局mixin方法
            _this3.resetTimeCode(function (time) {
              if (time <= 0) {
                _this3.disabled.sendCode = false;
              }
              _this3.surplusTime = time;
            });
          }
        }).catch(function () {
          // 还原发送验证码
          _this3.surplusTime = -2;
        });
      } else {
        this.$message({
          message: this.$t('817'),
          type: 'warning'
        });
      }
    },
    onAgree: function onAgree() {
      // 用户服务协议+使用条款埋点
      this.$ga.event('FHRSignup', 'click', 'UserAgreement', 3);
    },
    // 账号登录
    handleLogin: function handleLogin() {
      var _this4 = this;
      // 表单必填项验证
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this4.$ga.event('FHRSignup', 'click', 'NextStep', 4);
          _this4.loading = true;
          var msg = JSON.parse(JSON.stringify(_this4.ruleForm));
          registerApi(msg).then(function (res) {
            if (res && res.code === 1) {
              _this4.$s.set('userInfo', res.data.user_info);
              utilCookies.setToken(res.data.access_token);
              _this4.$router.push({
                path: '/register/team'
              });
            }
          }).finally(function () {
            _this4.loading = false;
          });
        }
      });
    }
  }
};